import * as cmOnOffTypes from '../../consts/communicationLayer/cmOnOffTypes';
import * as autoStartModeTypes from '../../consts/iot/autoStartModeTypes';
import * as responsiveDrawModeTypes from '../../consts/iot/responsiveDrawModeTypes';
import * as uamResponsiveDrawModeTypes from '../../consts/uam/uamResponsiveDrawModeTypes';
import * as yapUpdateSettingsTypes from '../../consts/yap/yapUpdateSettingsTypes';
import {makeSelectIotDeviceData} from '../../state/selectors/iotDevice';
import {getState} from '../../state/store';
import iotDeviceFWUStateService from '../iotDevice/iotDeviceFWUStateService';
import yapFWUService from '../yap/yapFWUService';
import uamClientService from './uamClientService';

const publishConnectionCareMessage = () => {};

const publishVibrationAlarmMessage = async () => {
    const message = {
        action: 'START',
        durationSeconds: 30,
    };

    return await uamClientService.findMyDevice(message);
};

const publishStopVibrationAlarmMessage = async () => {
    const message = {
        action: 'STOP',
    };

    return await uamClientService.findMyDevice(message);
};

const publishGetLedSettingsMessage = () => {};

const publishSetLedSettingsMessage = async (mode, isDeviceLedModeEnabled, isHolderLedModeEnabled) => {
    if (!mode) return;

    const message = {
        settingName: yapUpdateSettingsTypes.LED_INTENSITY,
        newValue: {intensity: mode},
    };
    const iotDevice = makeSelectIotDeviceData()(getState());
    const {holder, device} = iotDevice?.ledData || {};
    const holderLed = holder?.intensity;
    const deviceLed = device?.intensity;

    if (isDeviceLedModeEnabled && mode !== deviceLed) {
        await uamClientService.updateUamSettings(message);
    }

    if (isHolderLedModeEnabled && mode !== holderLed) {
        await uamClientService.updateUamSettings(message, true);
    }
};

const publishCheckFirmwareMessage = async (fwuTarget) => {
    iotDeviceFWUStateService.setIotTargetFwuStateOnFwuCheckRequest(fwuTarget);

    const result = await yapFWUService.getFirmwareAvailability(fwuTarget);

    if (!result) {
        iotDeviceFWUStateService.setIotTargetFwuStateOnFwuCheckRequest(fwuTarget, false);
    }
    return result;
};

const publishInitiateUpdateFirmwareMessage = async (fwuTarget) => {
    await yapFWUService.updateFirmware(fwuTarget, publishCheckFirmwareMessage);
};

const publishGetVibrationSettingsMessage = () => publishVibrationSettingsMessage();

const publishGetAutoStartSettingsMessage = () => publishAutoStartSettingsMessage();

const publishGetGestureSettingsMessage = () => publishGesturetSettingsMessage();

const publishGetResponsiveDrawSettingsMessage = () => publishResponsiveDrawSettingsMessage();

const publishGetVapeCloudSizeSettingsMessage = () => publishVapeCloudSizeSettingsMessage();

const publishGetCountdownSettingsMessage = () => publishCountdownSettingsMessage();

const publishSetResponsiveDrawSettingsMessage = (mode) => publishResponsiveDrawSettingsMessage(mode);

const publishSetVapeCloudSizeSettingsMessage = (mode) => publishVapeCloudSizeSettingsMessage(mode);

const publishSetAutoStartSettingsMessage = async (data) => {
    const autostart_feature_state = data?.holder?.autostart_feature_state;

    if (!autostart_feature_state) return;

    const onOffMessage =
        autostart_feature_state === autoStartModeTypes.AUTO_START_STATE_ENABLED ? cmOnOffTypes.ON : cmOnOffTypes.OFF;
    const message = {
        settingName: yapUpdateSettingsTypes.AUTO_START_HEATING,
        newValue: {featureState: onOffMessage},
    };

    await uamClientService.updateUamSettings(message, true);
};
const publishSetGestureSettingsMessage = async (data) => {
    const {status_gesture_pickup_enabled, status_gesture_double_tap_enabled} = data?.holder || {};

    let message = null;
    const getGestureState = (settingName, onOffMessage) => {
        return {settingName, newValue: {gestureState: onOffMessage}};
    };

    if (status_gesture_pickup_enabled !== undefined) {
        const onOffMessage = status_gesture_pickup_enabled ? cmOnOffTypes.ON : cmOnOffTypes.OFF;

        message = getGestureState(yapUpdateSettingsTypes.LIFT_UP_GESTURE, onOffMessage);
    }

    if (status_gesture_double_tap_enabled !== undefined) {
        const onOffMessage = status_gesture_double_tap_enabled ? cmOnOffTypes.ON : cmOnOffTypes.OFF;

        message = getGestureState(yapUpdateSettingsTypes.DOUBLE_TAP_GESTURE, onOffMessage);
    }

    if (message) {
        await uamClientService.updateUamSettings(message, true);
    }
};

const publishSetCountdownSettingsMessage = () => publishCountdownSettingsMessage();

const publishResetVibrationSettingsMessage = () => publishVibrationSettingsMessage();

const publishVibrationSettingsMessage = () => {};

const publishAutoStartSettingsMessage = () => {};

const publishGesturetSettingsMessage = () => {};

const publishCleaningMessage = async () => {
    await uamClientService.autoClean();
};

const publishCleaningCheckMessage = async () => {};

const publishCountdownSettingsMessage = () => {};

const publishDeviceRestartMessage = async (isHolder) => {
    return uamClientService.resetMyDevice(isHolder);
};

const publishDeviceStatusCharacteristicUsbMessage = () => {};

const publishBatteryInfoCharacteristicUsbMessage = () => {};

const publishResponsiveDrawSettingsMessage = async (mode) => {
    const message = {
        settingName: yapUpdateSettingsTypes.RESPONSIVE_DRAW_PROFILE,
    };

    if (mode) {
        if (mode === responsiveDrawModeTypes.VIVACE) {
            mode = uamResponsiveDrawModeTypes.ALLEGRO;
        } else if (mode === responsiveDrawModeTypes.STACCATO) {
            mode = uamResponsiveDrawModeTypes.VIVALDI;
        }
        message.newValue = {hapticPattern: mode};
    }

    await uamClientService.updateUamSettings(message);
};

const publishVapeCloudSizeSettingsMessage = async (mode) => {
    const message = {
        settingName: yapUpdateSettingsTypes.VAPE_CLOUD_SIZE,
    };

    if (mode) {
        message.newValue = {heatingProfile: mode};
    }

    await uamClientService.updateUamSettings(message);
};

const publishSessionProfilingSettingsMessage = async (puffData) => {
    const {puffNumber, puffingTime} = puffData || {};

    const message = {
        settingName: yapUpdateSettingsTypes.SESSION_PROFILING,
        newValue: {puffNumber, puffingTime},
    };

    await uamClientService.updateUamSettings(message);
};

export default {
    publishCheckFirmwareMessage,
    publishCleaningMessage,
    publishConnectionCareMessage,
    publishGetAutoStartSettingsMessage,
    publishGetCountdownSettingsMessage,
    publishGetGestureSettingsMessage,
    publishGetLedSettingsMessage,
    publishGetResponsiveDrawSettingsMessage,
    publishGetVapeCloudSizeSettingsMessage,
    publishGetVibrationSettingsMessage,
    publishCleaningCheckMessage,
    publishInitiateUpdateFirmwareMessage,
    publishResetVibrationSettingsMessage,
    publishSetAutoStartSettingsMessage,
    publishSetCountdownSettingsMessage,
    publishSetGestureSettingsMessage,
    publishSetLedSettingsMessage,
    publishSetResponsiveDrawSettingsMessage,
    publishSetVapeCloudSizeSettingsMessage,
    publishStopVibrationAlarmMessage,
    publishVibrationAlarmMessage,
    publishDeviceRestartMessage,
    publishDeviceStatusCharacteristicUsbMessage,
    publishBatteryInfoCharacteristicUsbMessage,
    publishSessionProfilingSettingsMessage,
};
